import _api from '../_api';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    coupons: [],
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.coupons,
  },
  // -----------------------------------------------------------------
  mutations: {
    setCoupons: (state, coupons,) => (state.coupons = coupons),
  },
  // -----------------------------------------------------------------
  actions: {
    get: ({ commit, },) => {
      return _api.get().then(
        (response,) => {
          const coupons = response.data.map((coupon,) => {
            return {
              ...coupon,
              formattedType: coupon.coupon.percent ? '%' : 'R$',
              isActive: coupon.status === 'enabled',
              createdAt: new Date(coupon.created_at,).toLocaleDateString('pt-BR',),
              updatedAt: coupon?.updated_at ? 
                new Date(coupon.updated_at,).toLocaleDateString('pt-BR',) :
                '',
            };
          },);

          commit('setCoupons', coupons,);

          return coupons;
        },
      );
    },

    enable: (_, payload,) => {
      return _api.enable(payload.id,);
    },

    disable: (_, payload,) => {
      return _api.disable(payload.id,);
    },

    save: (_, payload,) => {
      return _api.save(payload,);
    },

    update: (_, payload,) => {
      return _api.update(payload.id, payload.couponPackage,);
    },

    getCities (_, { franchises, size, from, },) {
      return _api.getCities({
        franchises,
        size,
        from,
      },).then((response,) => {
        const { data, } = response;

        return data;
      },);
    },
  },
};
